const addons = {
  // Storefront page
  pageTitle: 'Add-ons',
  pageSubtitle: 'Boost your listings with premium add-ons and services',
  myAddonsTitle: 'My add-ons',
  myAddonsEmpty: 'You have not purchased any add-ons yet.',
  catalogEmpty: 'No add-ons are available right now. Please check back later.',
  signInToBuy: 'Sign in to purchase add-ons',
  loadError: 'Failed to load add-ons',

  // Families
  family: {
    VISIBILITY_LIFECYCLE: 'Visibility & Lifecycle',
    LISTING_ENRICHMENT: 'Listing Enrichment',
    AI_STUDIO: 'AI Studio',
    TRUST_VERIFICATION: 'Trust & Verification',
    PROFESSIONAL_CONTENT: 'Professional Content',
    PERSONAL: 'Personal',
    OTHER: 'Other',
  },

  // Audiences
  audience: {
    OWNER: 'Owner',
    BROKER: 'Broker',
    COMPANY: 'Company',
    ALL: 'Everyone',
  },

  // Fulfillment
  fulfillment: {
    AUTO: 'Instant',
    MANUAL_ORDER: 'Manual order',
  },

  // Purchase statuses
  status: {
    PENDING_PAYMENT: 'Pending payment',
    PENDING_FULFILLMENT: 'Pending fulfillment',
    ACTIVE: 'Active',
    FULFILLED: 'Fulfilled',
    EXPIRED: 'Expired',
    CANCELLED: 'Cancelled',
    REFUNDED: 'Refunded',
  },

  // Pricing
  priceSar: '{{price}} SAR',
  quoteBased: 'Request a quote',
  free: 'Free',
  coinPrice: '{{count}} coins',
  yourBalance: 'Your balance',
  planDiscountNote: 'Your plan: −{{percent}}% on all add-ons',

  // Buttons
  buy: 'Buy',
  payWithCoins: 'Pay with coins',
  request: 'Request',
  pay: 'Pay now',
  cancel: 'Cancel',
  fulfilled: 'Mark fulfilled',
  setPrice: 'Set price',
  processing: 'Processing...',

  // Toasts
  purchaseSuccess: 'Add-on purchased and activated successfully',
  payWithCoinsSuccess: 'Add-on activated. Coins deducted from your balance.',
  insufficientCoins: 'Not enough coins. Top up your balance and try again.',
  requestReceived: 'Your request has been received. We will get back to you shortly.',
  paySuccess: 'Payment successful. Your add-on is now active.',
  cancelSuccess: 'Add-on purchase cancelled',
  actionError: 'Something went wrong. Please try again.',

  // Non-refundable purchase confirmation (shown before every paid action)
  confirm: {
    title: 'Confirm purchase',
    message: 'This purchase is final and cannot be refunded once activated. Do you want to continue?',
    coinsMessage: 'This will deduct {{count}} coins from your balance and is non-refundable. Continue?',
    cta: 'Confirm purchase',
  },

  // My add-ons page (use / apply owned entitlements)
  myAddons: {
    pageTitle: 'My add-ons',
    pageSubtitle: 'Use the add-ons you own - apply property add-ons to a listing, or see your active personal services.',
    empty: 'You have not purchased any add-ons yet.',
    browse: 'Browse add-ons',
    readyToUse: 'Ready to use',
    useCta: 'Use',
    accountActive: 'Active on your account',
    appliedTo: 'Applied to {{name}}',
    fromBundle: 'From a bundle',
    standalone: 'Individual add-ons',
    pickPropertyTitle: 'Choose a listing',
    pickPropertySubtitle: 'Select which of your listings to apply this add-on to.',
    noApplicableProperties: "You don't have any listings to apply this to yet.",
    createListing: 'Create a listing',
    applySuccess: 'Add-on applied to your listing.',
    applyError: 'Could not apply the add-on. Please try again.',
    loadError: 'Failed to load your add-ons.',
  },

  // Admin: catalog
  admin: {
    catalogTitle: 'Add-ons',
    catalogSubtitle: 'Manage the add-on catalog',
    ordersTitle: 'Add-on orders',
    ordersSubtitle: 'Fulfill and manage add-on purchases',
    addAddon: 'Add add-on',
    editAddon: 'Edit add-on',
    createAddon: 'Create add-on',
    deleteConfirm: 'Are you sure you want to delete "{{name}}"? If it has purchases it will be deactivated instead.',
    emptyCatalog: 'No add-ons yet. Create one to get started.',
    emptyOrders: 'No add-on orders found.',
    allFamilies: 'All families',
    allStatuses: 'All statuses',
    allFulfillment: 'All fulfillment types',

    // Field labels
    fieldSlug: 'Slug',
    fieldSlugHint: 'Unique identifier. Cannot be changed later.',
    fieldName: 'Name (English)',
    fieldNameAr: 'Name (Arabic)',
    fieldDescription: 'Description (English)',
    fieldDescriptionAr: 'Description (Arabic)',
    fieldFamily: 'Family',
    fieldFulfillment: 'Fulfillment',
    fieldAudiences: 'Audiences',
    fieldPriceSar: 'Price (SAR)',
    fieldPriceSarHint: 'Leave empty for quote-based add-ons.',
    fieldPriceCoins: 'Price (coins)',
    fieldQuoteBased: 'Quote-based (price on request)',
    fieldDurationDays: 'Duration (days)',
    fieldActive: 'Active (visible in store)',
    fieldSortOrder: 'Sort order',
    fieldMetadata: 'Metadata (JSON)',
    metadataInvalid: 'Metadata must be valid JSON',
    audiencesRequired: 'Select at least one audience',

    // Table columns
    colName: 'Name',
    colFamily: 'Family',
    colAudiences: 'Audiences',
    colFulfillment: 'Fulfillment',
    colPrice: 'Price',
    colStatus: 'Status',
    colActions: 'Actions',
    colBuyer: 'Buyer',
    colAddon: 'Add-on',
    colCreated: 'Created',
    colActive: 'Active',
    colInactive: 'Inactive',

    // Order actions
    setPriceTitle: 'Set quote price',
    setPriceLabel: 'Price (SAR)',
    orderNotes: 'Notes (optional)',
    markFulfilled: 'Mark fulfilled',
    cancelOrder: 'Cancel order',
    save: 'Save',
    saving: 'Saving...',
    saveError: 'Failed to save changes',
    createError: 'Failed to create add-on',
    updateError: 'Failed to update add-on',
    deleteError: 'Failed to delete add-on',
  },
};

export default addons;
